<template>
  <div ref="flashSale" id="active" class="flash__sale active" v-if="goodsList.length">
    <div class="flash__sale__header">
      <span class="flash__sale__header__title">{{ active.name }}</span>
      <el-button v-if="active.more" plain class="flash__sale__header__more" @click="clickMore">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <SlideWrap :onceSlideWidth="1175">
      <GoodsInfo
        mini
        :itemStyle="itemStyle"
        :imgStyle="imgStyle"
        class="pointer"
        v-for="goods in goodsList"
        :key="goods.itemCode"
        :goods="goods"
        :purchaseAble="true"
        @update-cart="updateCart"
        @click-goods="linkToGoodsDetails(goods)"
      />
    </SlideWrap>
  </div>
</template>

<script>
import * as api from '@/services';
import SlideWrap from '@/components/SlideWrap';
import GoodsInfo from '@/components/GoodsInfo';

export default {
  props: {
    max: {
      type: Number,
      default: 0
    },
    active: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    SlideWrap,
    GoodsInfo
  },
  computed: {
    goodsList() {
      return this.active.goods;
    }
  },
  inject: ['home'],
  data() {
    return {
      itemStyle: {
        margin: '0 6px 16px 6px',
        width: '219px',
        height: '360px'
      },
      imgStyle: {
        width: '195px',
        height: '195px'
      }
      // goodsList: []
    };
  },
  methods: {
    // async getGoodsList() {
    // let { name, goodsManual } = this.active;
    // let params = {
    //   activityItemMaxCount: this.max,
    //   itemCodes: goodsManual.join()
    // };
    // if (goodsManual.length < params.activityItemMaxCount) {
    //   params.itemActivityLabel = name;
    // }
    // const list = await api.goods.getActiveGoodsList(params);
    // this.goodsList = list;
    // this.goodsList = this.active.goods;

    // },
    clickMore() {
      window.open(this.active.more);
    },
    updateCart() {
      // Telescope.trackEvent({
      //   trackId: 'zyb2bpc-event-ssy-ssjgydjjganB2B',
      // })
      // 加购成功获取购物车数量
      this.$emit('update-cart');
    },
    linkToGoodsDetails(goods) {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-sy-scsytgkwdjspB2B',
        custom: {
          goodsCode: goods.itemCode,
          goodsName: goods.itemTitle,
          tabName: '商城首页',
          tabIndex: 0
        }
      })

      const search = this.home.$refs.search;
      search && search.clear();
      this.$router.push({ path: `/goodsDetails/${goods.itemCode}` });
    }
  },
  created() {
    // this.getGoodsList();
  }
};
</script>

<style lang="scss" scoped>
.flash__sale {
  // &:nth-child(4n + 1) {
  //   margin-left: 0;
  // }
  &__header {
    margin-top: 32px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    &__title {
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      line-height: 1;
    }
    &__more {
      padding-right: 0;
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
      border: none;
    }
  }
  ::v-deep .goods__item + .goods__item {
    margin-left: 16px;
  }
}
</style>
